module.exports = __webpack_public_path__ + "img/118.4.a0f3b42c.png";